<template>
  <div class="products-index-base" :style="styles">
    <h1><img src="/static/img/recommend/lp/houen/products/newcorner_lp_head_houen.png" alt="法演のMITSURI占い特集"></h1>
    <!--
    <div class="header-title-box">
      <h2>暴露数とは</h2>
      <p>暴露数は、隠れた本当のあなたを発見できる占いです。この暴露数鑑定書では、あなたのの中にある、２つの個性を導き出します。その２つの個性は、状況によって、表に出てくる個性が違います。それぞれの個性を知ることで、これまで不思議だった人の行動や、さらに深く自分自身を知るきっかけになるはずです。</p>
    </div>
    -->

    <block-daily-fortune
      v-if="hasResult"
      :result-list="dairyFortuneResult"
      :color-scheme="colorScheme"
    />

    <div class="block-regist-birthdate" v-else>
      <regist-birthdate
        :csrf-token="csrfToken"
      />
    </div>

    <div class="block-yearluck-banner">
      <a href="/2023_luck/input/6406">
        <img src="/static/img/recommend/lp/houen/products/bnr_yearluck2023a.png" alt="">
      </a>
    </div>

    <!--
    <block-today-word
      v-if="hasResult"
      :logic-list="logicList"
    />
    -->

    <div class="block-subscr-menus" v-if="hasResult">
      <block-houen-menus
        v-for="(item, idx) in houenMenuList"
        :key="`list${idx}`"
        :menu-data="item"
        :color-scheme="colorScheme"
      />
    </div>

    <block-special-appraisal
      :appraisal-list="specialAppraisalList"
      :color-scheme="colorScheme"
    />

    <block-bakuro-num-apprisal
      v-if="hasResult"
      :items-list="bakuroNumAppraisalList"
      :result-data="resultData"
      :csrf-token="csrfToken"
      :color-scheme="colorScheme"
    />

    <block-coming-soon
      :color-scheme="colorScheme"
    />

    <!-- <banner-block /> -->
    <recommend-block-plus
      :recommend-data="standardRecommendData"
      :color-scheme="recommendColorScheme"
    />

    <lp-footer
      :color-scheme="footerColorScheme"
      :menu-list="footerMenuList"
      :scroll-pos="scrollPos"
      :lp-id="6"
    />
  </div>
</template>

<script>
import moment from 'moment'
import {BASIC_DATA, DEFAULT_FOOTER_MENULIST } from '@/utvStore/components/recommend/lp/commons'
import * as type from '@/utvStore/store/mutation-types'
import BannerBlock from './partials/BannerBlock'
import RegistBirthdate from './partials/RegistBirthdate'
import BlockBakuroNumApprisal from './partials/BlockBakuroNumApprisal'
import BlockDailyFortune from './partials/BlockDailyFortune'
import BlockTodayWord from './partials/BlockTodayWord'
import BlockHouenMenus from './partials/BlockHouenMenus'
import BlockSpecialAppraisal from './partials/BlockSpecialAppraisal'
import BlockComingSoon from './partials/BlockComingSoon'
import RecommendBlockPlus from '@/utvStore/components/common/RecommendBlockPlus'
import LpFooter from '@/utvStore/components/recommend/lp/blocks/LpFooter'

const BAKURO_NUM_APPRAISAL_ITEM_LIST = [
  { url: '/products/45/0001/result', title: 'あなたの本質について', is_new: '0' },
  { url: '/products/45/0002/result', title: 'あなたの恋愛について', is_new: '0' },
  { url: '/products/45/0003/result', title: 'あなたの仕事について', is_new: '0' },
  { url: '/products/45/0009/result', title: '対人運と人間関係', is_new: '1' },
  { url: '/products/45/0010/result', title: '結婚運命と異性運', is_new: '1' },
  // { url: '/products/45/0006/result', title: '2つの暴露数について', is_new: '1' },
]

const SPECIAL_APPRAISAL_LIST = [
  {
    title: '運命の人ってどんな人？',
    image: '/static/img/recommend/lp/houen/products/img_special_apprisal_1.png',
    list: [
      {
        title: 'あなたの運命の人の特徴',
        url: '/products/45/0004/result',
        is_new: '1',
      },
      {
        title: '運命の人の生まれ月',
        url: '/products/45/0005/result',
        is_new: '1',
      },
    ]
  },
  {
    title: '運命の人ってどんな人？',
    image: '/static/img/recommend/lp/houen/products/img_special_apprisal_2.png',
    list: [
      {
        title: '金運を下げる行動・上げる行動',
        url: '/products/45/0006/result',
        is_new: '0',
      },
      {
        title: '恋愛運を下げる行動・上げる行動',
        url: '/products/45/0007/result',
        is_new: '0',
      },
      {
        title: '仕事運を下げる行動・上げる行動',
        url: '/products/45/0008/result',
        is_new: '0',
      },
    ]
  },
]

export default {
  name: 'ProductsHouenIndex',
  components: {
    BlockSpecialAppraisal,
    BlockHouenMenus,
    BlockTodayWord,
    BlockDailyFortune,
    BlockBakuroNumApprisal,
    BlockComingSoon,
    RegistBirthdate,
    BannerBlock,
    RecommendBlockPlus,
    LpFooter,
  },
  props: {
    resultData: {
      //type: Object,
      type: [Object, Array],
      default() {
        return null
      }
    },
    pickupData: {
      type: Object,
      default() {
        return {}
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    specialAppraisalList: { // フロント管理データ
      type: Array,
      default() {
        return SPECIAL_APPRAISAL_LIST
      }
    },
    bakuroNumAppraisalList: { // フロント管理データ
      type: Array,
      default(){
        return BAKURO_NUM_APPRAISAL_ITEM_LIST
      }
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
    standardRecommendData: {
      type: Array,
    }
  },
  data(){
    return {
      scrollPos: -1,
    }
  },
  computed: {
    hasResult() {
      return !!this.resultData && Array.isArray(this.resultData) ? this.resultData.length > 0 : Object.keys(this.resultData).length > 0
    },
    logicList() {
      if(this.hasResult && !!this.resultData.logic_list && this.resultData.logic_list.length === 12) {
        return this.resultData.logic_list
      }
    },
    footerColorScheme() {
      const sch = this.counselorInfos.colorScheme
      return {
        keyColor: sch.baseBg,
        fontColor: 'white',
        second: '#4d89c4',
      }
    },
    footerMenuList() {
      return [
        // { label: `法演TOP`, url: `/products/45`},
        ...DEFAULT_FOOTER_MENULIST,
      ]
    },
    houenMenuList() {
      if(this.hasResult) {
        return this.resultData.menu_list.filter(item => {
          return item.list.length > 0
        })
      }
    },
    dairyFortuneResult() {
      if(this.hasResult){
        return this.resultData.result1
      }
    },
    counselorInfos() {
      return BASIC_DATA.houen
    },
    recommendColorScheme() {
      return {
        keyColor: this.counselorInfos.colorScheme.keyColor,
      }
    },
    styles(){
      return {
        '--key-color': this.counselorInfos.colorScheme.keyColor,
        '--mess-bg': this.counselorInfos.colorScheme.messBg,
        '--second': this.counselorInfos.colorScheme.second,
      }
    },
  },
  created() {
    this.$store.dispatch(type.SET_COLOR_SCHEME, this.counselorInfos.colorScheme)
  },
  mounted() {
    console.log('resultData:%O', this.resultData)
    window.addEventListener('scroll', this.onScroll)
    this.onScroll()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    onScroll(){
      this.scrollPos = window.scrollY
    },
  }
}</script>

<style scoped lang='scss'>
@import "../../../../../sass/commons/commonVariables.scss";
@import "../../../../../sass/commons/styles/fonts";


/deep/ {
  img {
    max-width: 100%;
    display: block;
  }
  p {
    margin: 0 auto 24px;
  }
  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }
}
h1 {
  margin: 0;
}
.products-index-base {
  background: url(/static/img/recommend/lp/houen/products/bk_result.png) repeat-y;
  background-size: 100% auto;
}
.head-img-pickup{
  width: 284px;
  margin: auto;
  margin-bottom: 12px;
}

.block-yearluck-banner {
  padding: 40px 20px;
  background: white;
}

.header-title-box{
  padding:16px 20px 24px;
  h2{
    @extend .source-han-serif-bold;
    font-size: 24px;
    line-height: 32px;
    border-bottom:1px solid var(--key-color) ;
    margin: 0 auto 24px;
    text-align: center;
    display: block;
    width: 180px;
    color: var(--key-color);
    letter-spacing: 6px;
    padding-bottom: 10px;
  }
  p{
    color: $col_base_black;
    margin:0;
  }
}

.block-subscr-menus {
  padding: 32px 20px 44px;
  /deep/ .block-houen-menus {
    margin-bottom: 16px;
  }
}

.block-regist-birthdate {
  padding:  0 20px 20px;
  /deep/ .regist-birthdate {
    background: rgba( 255, 255, 255, 0.7 );
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/ProductsHouenIndex.vue